import { IStackProps } from 'office-ui-fabric-react';

export const stackProps: IStackProps = { gap: 16, padding: 8, maxWidth: 400 };
